<template>
  <transition name="fade">
    <div
        v-if="showModal"
        class="apg-modal-backdrop apg-modal-full"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="`${source}-modal-title`"
    >
      <div class="apg-modal">
        <header class="apg-modal-header">
          <h3 :id="`${source}-modal-title`">{{ modalTitle }}</h3>
          <button
              type="button"
              class="btn-close"
              title="Close"
              aria-label="Close"
              @click="closeModal"
          >
            <i class="bi bi-x-lg"></i>
          </button>
        </header>

        <section class="apg-modal-body">
          <slot />
        </section>

        <footer class="apg-modal-footer"></footer>
      </div>
    </div>
  </transition>
</template>

<script>
import {useStore} from "vuex";
import {computed} from 'vue';
export default {
	name: 'BasicModal',
  props: {
    modalTitle: String,
    source: String,
  },
	setup(props)
	{
		const store = useStore();
		return {
			showModal: computed(()=>store.state.apgList.modals[props.source]),
      closeModal: () => store.commit('apgList/hideModal',{listType:props.source})
		}
	}
}
</script>

<style scoped>
/* Scoped, higher‑specificity selectors */
.apg-modal .apg-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}

.apg-modal .apg-modal-header h3 {
  margin: 0;
  font-size: 1rem;
  color: var(--color-txt);
}

.apg-modal .btn-close {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--color-txt);
}

.apg-modal .btn-close:hover {
  color: var(--color-sec);
}
</style>

